import React, {useEffect} from 'react';
import FacebookLogin from 'react-facebook-login/dist/facebook-login-render-props';
import { FACEBOOK_LOGIN_APP_ID } from '../global/components/Constants';
import { userThirdPartyLogin } from '../utils/api-services/user';
import aMediator from './aMediator';

const FacebookLoginButton = ({label, entry, code}) => {

    useEffect(() => {
        // Only load if FB is not already present
        if (!window.FB) {
          const script = document.createElement('script');
          script.src = 'https://connect.facebook.net/en_US/sdk.js';
          script.async = true;
          script.defer = true;
          script.crossOrigin = 'anonymous';
    
          script.onload = () => {
            window.FB.init({
              appId: FACEBOOK_LOGIN_APP_ID,
              cookie: true,
              xfbml: false,
              version: 'v18.0', // MUST be valid and available version
            });
          };
    
          document.body.appendChild(script);
        } else {
          // Already loaded
          window.FB.init({
            appId: FACEBOOK_LOGIN_APP_ID,
            cookie: true,
            xfbml: false,
            version: 'v18.0',
          });
        }
    }, []);

    const handleLogin = () => {

        if (!window.FB) {
          alert('Facebook SDK not loaded. Try again.');
          return;
        }
    
        window.FB.login(function (response) {
          if (response.authResponse) {
            window.FB.api('/me', { fields: 'name,email' }, function (userData) {
                console.log('User:', userData);
                if(userData != null){
                    saveLogin({
                        name: userData.name,
                        email: userData.email,
                        photo: "",
                        entry: "Facebook"
                    });
                }
            });
          } else {
            console.log('Login cancelled or not authorized');
          }
        }, { scope: 'public_profile,email' });
    }

    const saveLogin = async (payload) => {
        const obj = await userThirdPartyLogin(payload);
        if(obj?.Success){
            localStorage.setItem("session", obj.Data);
            aMediator(entry, code);
        }
    }

    const styles = {
        btn: {
            backgroundColor: '#fff',
            color: '#3c4043',
            width: '100%',
            padding: '7px',
            border: 'none',
            borderRadius: '5px',
            fontSize: '15px',
            border: '1px solid #dadce0',
            cursor: 'pointer',
            position: 'relative'
        },
        icon:{
            color: '#000099',
            fontSize: 18,
            position: 'absolute',
            top: 11,
            left: 13
        }
    }

    return (
        <button onClick={handleLogin} style={styles.btn}>
            <i className="fa fa-facebook" style={styles.icon}></i> {label}
        </button>
    )

}

export default FacebookLoginButton;